<!-- <form (submit)="get_year_filter($event)" method="get">
	<div class="row">
		<div class="col-lg-3">
			<div class="mt-3">
				<label for="autoCompleteCampaigns" class="form-label mb-0">Search By Campaign</label>
				<ng-autocomplete
					[data]="campaignList"
					[searchKeyword]="keyword"
					placeholder="Enter Campaign Name"
					(selected)="selectEventCampaignYear($event)"
					(inputChanged)="onChangeSearch($event)"
					(inputFocused)="onFocused($event)"
					historyIdentifier="campaignList"
					[itemTemplate]="itemTemplate"
					[notFoundTemplate]="notFoundTemplate"
				>
				</ng-autocomplete>
				<ng-template #itemTemplate let-item>
					<a [innerHTML]="item.name"></a>
				</ng-template>

				<ng-template #notFoundTemplate let-notFound>
					<div [innerHTML]="notFound"></div>
				</ng-template>
			</div>
		</div>
		<div class="col-lg-3">
			<div class="mt-3">
				<label for="autoCompleteTypes" class="form-label mb-0">Search By Type</label>
				<ng-autocomplete
					[data]="campaignTypeList"
					[searchKeyword]="keyword"
					placeholder="Enter the Type"
					(selected)="selectEventTypeYear($event)"
					(inputChanged)="onChangeSearch($event)"
					(inputFocused)="onFocused($event)"
					historyIdentifier="campaignTypeList"
					[itemTemplate]="itemTemplate"
					[notFoundTemplate]="notFoundTemplate"
				>
				</ng-autocomplete>

				<ng-template #itemTemplate let-item>
					<a [innerHTML]="item.name"></a>
				</ng-template>

				<ng-template #notFoundTemplate let-notFound>
					<div [innerHTML]="notFound"></div>
				</ng-template>
			</div>
		</div>
		<div class="col-lg-3">
			<div class="mt-3">
				<label for="autoCompletePeriods" class="form-label mb-0">Select Year</label>
				<ng-autocomplete
					[data]="campaignPeriods"
					[searchKeyword]="keyword"
					placeholder="Select year"
					(selected)="selectEventPeriod($event)"
					(inputChanged)="onChangeSearch($event)"
					(inputFocused)="onFocused($event)"
					historyIdentifier="campaignPeriods"
					[itemTemplate]="itemTemplate"
					[notFoundTemplate]="notFoundTemplate"
				>
				</ng-autocomplete>

				<ng-template #itemTemplate let-item>
					<a [innerHTML]="item.name"></a>
				</ng-template>

				<ng-template #notFoundTemplate let-notFound>
					<div [innerHTML]="notFound"></div>
				</ng-template>
			</div>
		</div>
		<div class="col-lg-3">
			<div class="mt-3" style="padding-top: 19px;">
				<button type="submit" class="btn btn-md btn-success edit-item-btn">Search</button>
			</div>
		</div>
	</div>
</form> -->
<div
	*ngIf="isHidden"
	class="alert alert-warning text-center"
	[style.margin-top]="'10px'"
>
	You need to select a year
</div>
<div class="alert alert-info text-center">
	These are the real data of leads from the previous year, on this screen they
	are shown in an informative way
</div>
<div class="table-responsive table-card mt-3 mb-1">
	<table class="table">
		<thead class="bg-light">
			<tr class="bg-light text-muted">
				<th class="sort" data-sort="id">Campaign</th>
				<th class="sort" data-sort="description">Type</th>
				<th class="sort" data-sort="amount">Lead Cost</th>
				<th class="sort" data-sort="amount">January</th>
				<th class="sort" data-sort="amount">February</th>
				<th class="sort" data-sort="amount">March</th>
				<th class="sort" data-sort="amount">April</th>
				<th class="sort" data-sort="amount">May</th>
				<th class="sort" data-sort="amount">June</th>
				<th class="sort" data-sort="amount">July</th>
				<th class="sort" data-sort="amount">August</th>
				<th class="sort" data-sort="amount">September</th>
				<th class="sort" data-sort="amount">October</th>
				<th class="sort" data-sort="amount">November</th>
				<th class="sort" data-sort="amount">December</th>
				<th class="sort" data-sort="amount">Total Leads</th>
				<th class="sort" data-sort="amount">Total Revenue</th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let data_year of ListJsListYear$ | async">
				<!--td><ngb-highlight  [result]="data_year.id" [term]="serviceyear.searchTerm"></ngb-highlight></td-->
				<td>
					<span class="text-muted">{{ data_year.name }}</span>
				</td>
				<td>{{ data_year.type }}</td>
				<td>{{ data_year.lead_cost }}</td>
				<td>{{ data_year.january }}</td>
				<td>{{ data_year.february }}</td>
				<td>{{ data_year.march }}</td>
				<td>{{ data_year.april }}</td>
				<td>{{ data_year.may }}</td>
				<td>{{ data_year.june }}</td>
				<td>{{ data_year.july }}</td>
				<td>{{ data_year.august }}</td>
				<td>{{ data_year.september }}</td>
				<td>{{ data_year.october }}</td>
				<td>{{ data_year.november }}</td>
				<td>{{ data_year.december }}</td>
				<td>{{ data_year.total_leads }}</td>
				<td>{{ data_year.total_revenue }}</td>
			</tr>
		</tbody>
	</table>
</div>
<div class="row justify-content-md-between align-items-md-center gy-2">
	<div class="col col-sm-6">
		<div
			class="dataTables_info mb-2"
			id="tickets-table_info"
			role="status"
			aria-live="polite"
		>
			<div *ngIf="isSearch; then thenBlock; else elseBlock"></div>
			<ng-template #thenBlock>
				Showing
				{{ serviceyearsearch.startIndex }} to
				{{ serviceyearsearch.endIndex }} of
				{{ serviceyearsearch.totalRecords }}
				entries
			</ng-template>
			<ng-template #elseBlock>
				Showing Showing
				{{ serviceyear.startIndex }} to {{ serviceyear.endIndex }} of
				{{ serviceyear.totalRecords }}
				entries
			</ng-template>
		</div>
	</div>
	<div class="col col-sm-6">
		<div class="text-sm-right float-sm-end listjs-pagination">
			<div
				*ngIf="isSearch; then thenPagination; else elsePagination"
			></div>
			<ng-template #thenPagination>
				<ngb-pagination
					[collectionSize]="(totalYear$ | async)!"
					[(page)]="serviceyearsearch.page"
					[pageSize]="serviceyearsearch.pageSize"
				>
				</ngb-pagination>
			</ng-template>
			<ng-template #elsePagination>
				<ngb-pagination
					[collectionSize]="(totalYear$ | async)!"
					[(page)]="serviceyear.page"
					[pageSize]="serviceyear.pageSize"
				>
				</ngb-pagination>
			</ng-template>
		</div>
	</div>
</div>
